import { ENDPOINTS } from '../../network/endpoints';

/** @implements {import('../../../contracts/IWidgetRepository').IWidgetRepository} */
export class WidgetRepository {
  /** @param {import('../../../contracts/IHttpClient').IHttpClient} client */
  constructor(client) {
    this.client = client;
  }

  async getWidgetConfiguration(agentId, options = {}) {
    return this.client.get(ENDPOINTS.AGENTS.WIDGET(agentId), {
      params: options,
    });
  }

  async uploadAgentAvatar(agentId, avatarFile) {
    const formData = new FormData();
    formData.append('avatar_file', avatarFile);
    return this.client.post(ENDPOINTS.AGENTS.AVATAR(agentId), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  async getAgentLink(agentId) {
    return this.client.get(ENDPOINTS.AGENTS.LINK(agentId));
  }
}
